import createDataContext from './createDataContext';
import * as actions from './actions/tankLevelTemplateActions';
import { reducer, initialState } from './reducers/tankLevelTemplateReducer';

export const { Context: TankLevelTemplateContext, Provider } = createDataContext(
  reducer,
  actions,
  initialState
);
